const CustomIconFacebook = () => (
  <svg
    width="8"
    height="16"
    viewBox="0 0 8 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.9873 15.8967H1.66176V8.05476H0V5.35271H1.66176V3.73048C1.66176 1.52628 2.59957 0.214844 5.2657 0.214844H7.48476V2.91789H6.09785C5.05995 2.91789 4.99136 3.29548 4.99136 4.0002L4.98679 5.35271H7.5L7.20585 8.05476H4.98679V15.8967H4.9873Z"
      fill="#F2F0EC"
    />
  </svg>
)

export default CustomIconFacebook
